import API from "../api/manager";
import config from "../api/config";

// EPE (JustCue). Every call goes to JustAct-Backend, which talks to the JustCue server: the browser never calls
// JustCue itself.

// A Presentation launch sends all the case's documents to JustCue first, which can take minutes.
const LAUNCH_TIMEOUT_MS = 300000;

const getAccess = (caseId) => {
  return API({
    method: "GET",
    url: config.urls.epe.access(caseId),
  });
};

/** target: "presentation" | "evidence"; returnUrl: where JustCue's "Back to JustAct" link leads. */
const launch = (caseId, target, returnUrl) => {
  return API({
    method: "POST",
    url: config.urls.epe.launch(caseId),
    data: { target, returnUrl },
    timeout: LAUNCH_TIMEOUT_MS,
  });
};

const getParticipants = (caseId) => {
  return API({
    method: "GET",
    url: config.urls.epe.participants(caseId),
  });
};

const grantOperator = (caseId, userId) => {
  return API({
    method: "PUT",
    url: config.urls.epe.operator(caseId, userId),
  });
};

const revokeOperator = (caseId, userId) => {
  return API({
    method: "DELETE",
    url: config.urls.epe.operator(caseId, userId),
  });
};

const startNewSession = (caseId) => {
  return API({
    method: "POST",
    url: config.urls.epe.newSession(caseId),
    data: {},
  });
};

export default {
  getAccess,
  launch,
  getParticipants,
  grantOperator,
  revokeOperator,
  startNewSession,
};
